<div class="table-container">
    <aside class="locked">
        <table>
            <thead>
                <tr>
                    <th>{{'dashboard.datatables.byPartitions.partitions.shortLabel' | translate}}</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngIf="!isParamMode">
                    <ng-container *ngFor="let kpi of kpisByYear[0].kpis">
                        <tr *ngIf="kpi.ratio?.isVisible || kpi.amount?.isVisible" class="deep-0">
                            <td>{{kpi.text?.fullLabel}}</td>
                        </tr>
                    </ng-container>
                </ng-container>

                <tr
                    *ngFor="let row of partsRows; index as i;"
                    class="deep-{{row.deep}}"
                    [ngClass]="{
                        hidden: row.isHidden,
                        receipts: row.partition.partitionDetails.articleType === 'receipt',
                        spending: row.partition.partitionDetails.articleType === 'expense',
                        edited: row.partition.simulationValues.flag === flagType.modified }"
                    (click)="onToggleChildren(row)">
                    <td
                        class="label"
                        [ngClass]="{'last-child': row.isLast}"
                        [ngStyle]="{'padding-left': setRowPadding(row.deep)}">
                        <mat-icon *ngIf="!row.isLast">
                            {{row.isOpen ? 'expand_more' : 'chevron_right'}}
                        </mat-icon>
                        <mat-icon *ngIf="row.isLast"></mat-icon>
                        <span>{{row.partition.partitionDetails.text.shortLabel}}</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </aside>

    <section class="years-data">
        <table>
            <thead>
                <tr>
                    <th *ngFor="let column of columns">
                        <span *ngIf="column.isTranslated">{{column.label | translate}}</span>
                        <span *ngIf="!column.isTranslated">{{column.label}}</span>
                    </th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngIf="!isParamMode">
                    <ng-container *ngFor="let kpi of kpisByYear[0].kpis; let i=index;">
                        <tr *ngIf="kpi.ratio?.isVisible || kpi.amount?.isVisible">
                            <td *ngFor="let kpiYear of kpisByYear"  [ngClass]="{executed: !kpiYear.isEstimated}">
                                <span *ngIf="kpiYear.kpis[i].ratio?.isVisible">{{ kpiYear.kpis[i].ratio.value | formatPercent }}</span>
                                <span *ngIf="kpiYear.kpis[i].amount?.isVisible">{{ kpiYear.kpis[i].amount.value | formatAmount }}</span>
                            </td>
                        </tr>
                    </ng-container>
                </ng-container>

                <tr *ngFor="let row of partsRows; index as i;"
                    class="deep-{{row.deep}}"
                    [ngClass]="{
                        hidden: row.isHidden,
                        receipts: row.partition.partitionDetails.articleType === 'receipt',
                        spending: row.partition.partitionDetails.articleType === 'expense',
                        edited: row.partition.simulationValues.flag === flagType.modified}">

                    <ng-container *ngIf="isParamMode && !isMJP">
                        <td>
                            <span *ngIf="row.partition.isEditable && showCompletionRate">
                                {{ row.partition.completionRate | formatPercent }}
                            </span>
                        </td>
                        <td>
                            <span *ngIf="row.partition.isEditable">
                                {{ row.partition.projectionRate.rate | formatPercent }}
                            </span>
                        </td>
                    </ng-container>

                    <ng-container *ngFor="let rowYear of row.partition.simulationValues.years">
                        <td *ngIf="!isParamMode" [ngClass]="{executed: !rowYear.isEstimated}">
                            <span class="amount">{{ rowYear.amount | formatAmount }}</span>
                        </td>

                        <td *ngIf="isParamMode && rowYear.isEstimated">
                            <ng-container *ngIf="row.partition.simulationValues.flag === flagType.virtual">
                                <span class="amount">{{ rowYear.amount | formatAmount }}</span>
                            </ng-container>

                            <ng-container *ngIf="row.partition.isEditable && row.partition.simulationValues.flag !== flagType.virtual">
                                <span class="percent" *ngIf="rowYear.mode === indiceModeType.ac">{{ rowYear.indice }}</span>
                                <span class="percent" *ngIf="rowYear.mode === indiceModeType.percent">
                                    {{ (!isMJP || rowYear.isRateNeutralized ? rowYear.indice : (row.partition.projectionRate.rate + rowYear.indice)) | formatPercent }}
                                </span>
                                <span class="amount" *ngIf="rowYear.additionalAmount">{{ rowYear.additionalAmount | formatAmount }}</span>
                            </ng-container>
                        </td>
                    </ng-container>
                </tr>
            </tbody>
        </table>
    </section>
</div>
